import type { ReactNode } from 'react';
import SurveyLanguageDocumentSync from '@/components/layout/SurveyLanguageDocumentSync';

/**
 * Same idea as stockledger `SupervisorLayout` / login shell: fixed mobile width (`max-w-md`),
 * centered on wide screens with a subtle gutter so the app reads like a phone browser.
 */
export default function MobileAppFrame({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] w-full flex justify-center bg-slate-400/35">
      <SurveyLanguageDocumentSync />
      <div className="flex min-h-[100dvh] h-[100dvh] w-full max-w-md flex-col mx-auto shadow-[0_0_32px_rgba(0,0,0,0.2)] relative overflow-hidden">
        {children}
      </div>
    </div>
  );
}
